import { state } from "./state";
import type { Filters } from "./state";
import { escapeHtml, escapeAttr, byId } from "./dom";
import { renderGrid } from "./render";

export function renderFilters(): void {
  const items =
    state.view === "assets" ? state.index!.assets : state.index!.prefabs;

  const kindCounts = new Map<string, number>();
  const categoryCounts = new Map<string, number>();
  const tagCounts = new Map<string, number>();

  for (const item of items) {
    if (state.view === "assets" && "kind" in item && item.kind) {
      kindCounts.set(item.kind, (kindCounts.get(item.kind) || 0) + 1);
    }
    if (item.category) {
      categoryCounts.set(
        item.category,
        (categoryCounts.get(item.category) || 0) + 1,
      );
    }
    for (const t of item.tags || []) {
      tagCounts.set(t, (tagCounts.get(t) || 0) + 1);
    }
  }

  const sections: string[] = [];

  if (state.view === "assets" && kindCounts.size > 0) {
    sections.push(filterSection("Kind", "kinds", kindCounts));
  }
  if (categoryCounts.size > 0) {
    sections.push(filterSection("Category", "categories", categoryCounts));
  }
  if (
    state.view === "assets" &&
    (tagCounts.size > 0 || state.filters.tags.size > 0)
  ) {
    const merged = new Map(tagCounts);
    for (const t of state.filters.tags) {
      if (!merged.has(t)) merged.set(t, 0);
    }
    const sorted = [...merged.entries()].sort((a, b) => {
      const aActive = state.filters.tags.has(a[0]);
      const bActive = state.filters.tags.has(b[0]);
      if (aActive !== bActive) return aActive ? -1 : 1;
      if (b[1] !== a[1]) return b[1] - a[1];
      return a[0].localeCompare(b[0]);
    });
    sections.push(filterSection("Tags", "tags", new Map(sorted), true));
  }

  byId("filters").innerHTML = sections.join("");

  byId("filters")
    .querySelectorAll("input[type=checkbox]")
    .forEach((cbEl) => {
      cbEl.addEventListener("change", () => {
        const cb = cbEl as HTMLInputElement;
        const group = cb.dataset.group as keyof Filters;
        const value = cb.dataset.value!;
        const set = state.filters[group];
        if (cb.checked) set.add(value);
        else set.delete(value);
        cb.parentElement?.classList.toggle("active", cb.checked);
        renderGrid();
      });
    });
}

function filterSection(
  title: string,
  group: keyof Filters,
  counts: Map<string, number>,
  presorted = false,
): string {
  const entries = presorted
    ? [...counts.entries()]
    : [...counts.entries()].sort((a, b) => a[0].localeCompare(b[0]));
  const lines = entries
    .map(([value, count]) => {
      const checked = state.filters[group].has(value) ? "checked" : "";
      const activeCls = checked ? "active" : "";
      return `<label class="${activeCls}"><input type="checkbox" data-group="${escapeAttr(group)}" data-value="${escapeAttr(value)}" ${checked}/> ${escapeHtml(value)} <span class="count">${count}</span></label>`;
    })
    .join("");
  return `<h2>${escapeHtml(title)}</h2><div class="filter-group">${lines}</div>`;
}
